import TooltipEllipsis from '@deltek/specification-client/core/Feedbacks/TooltipEllipsis'
import React from 'react'
import { ColumnInstance, MetaBase } from 'react-table'
import GroupedCellDefault from '../GroupedCellDefault'

/**
 * Plugin that handles the grouping column.
 */
const groupedColumn = <TData extends Object>(
    sticky: boolean,
    canToggle: boolean,
    isProjectHome?: boolean
) => (
    columns: ColumnInstance<TData>[],
    { instance: { state } }: MetaBase<TData>
) => {
    if (!state.groupBy.length) {
        return columns
    }

    return [
        {
            id: 'groupColExpander',
            sticky: sticky ? 'left' : undefined,
            Header: ({ allColumns, state: { groupBy } }) => {
                const titleText: string[] = []
                const headerText = groupBy.map((colId, idx) => {
                    const column = allColumns.find((d) => d.id === colId)
                    titleText.push(column?.Header as string)
                    if (idx > 3) return null
                    return (
                        <span
                            className="header-text"
                            key={idx}
                            style={{
                                paddingLeft: `${idx * 2}rem`,
                                textOverflow: 'ellipsis',
                                overflow: 'hidden',
                                display: 'block',
                            }}
                        >
                            {idx === 3 ? '...' : column?.render('Header')}
                        </span>
                    )
                })

                return (
                    <TooltipEllipsis text={titleText.join(' > ')}>
                        <div style={{ paddingBottom: 8, paddingTop: 8 }}>
                            {headerText}
                        </div>
                    </TooltipEllipsis>
                )
            },
            Cell: GroupedCellDefault(canToggle, isProjectHome),
        },
        ...columns,
    ] as ColumnInstance<TData>[]
}

export default groupedColumn
